// EmailJS configuration
// Note: EmailJS public keys are meant to be exposed in frontend applications
// They are not secret keys and are designed to be used in client-side code
export const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_h0ns9zm',
  TEMPLATE_ID: 'template_n25q1vr', 
  PUBLIC_KEY: 'GeazWOazFlE07Nof7'
} as const;

// EmailJS public keys are safe to expose as they:
// 1. Can only send emails, not read/modify data
// 2. Are rate-limited by EmailJS
// 3. Require template configuration on EmailJS dashboard
// 4. Cannot be used to access other services